import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconExpandSimple2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="expand-simple-2"><path d="M12.75 18.25H18.25V12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.75 11.25V5.75H11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconExpandSimple2;
